import { Component } from "@angular/core";
import { OnInit } from "@angular/core";
import { CustomerService } from "src/app/services/customer.service";
import { StateService } from "src/app/services/states.service";
import { MatDialog } from '@angular/material';
import { GenerateVoucher } from "../dialogs-voucher/generate-voucher-dialog.component";
import { Router } from "@angular/router";

@Component({
    selector: 'app-coupon',
    templateUrl: './coupon.component.html',
    styleUrls: ['./coupon.component.scss']
})
export class CouponComponent implements OnInit {
    currentUser:any
    subscribe: any = []
    coupons:any = []
    headElements:any = ['Coupon', 'Date de création', 'Envoyé à', 'Statut', 'Utilisé par', 'Commentaire pour le bénéficiaire du coupon', 'Actions']
    filters:any = {
        sortCoupon : "Actif"
    }
    page:number= 1;
    pageSize:number=6;

    textCopied:any = false
    voucherCopied:string = ''
    countCredit: any = null
    couponsTotal: any = null
    couponsUsed: any = null
    couponsUnused: any = null
    couponsInUse: any = null
    constructor(
        public customerService: CustomerService,
        public stateService: StateService,
        public dialog: MatDialog,
        private router: Router
    ){}

    ngOnInit(){
        this.stateService.user.subscribe((user) => {
            if(user){
                this.currentUser = user
                this.searchCoupon()
                this.searchDataCoupons()
            } else {
                this.router.navigateByUrl("/homepage");
            }
        })
    }
    searchDataCoupons(){
        this.customerService.getDataCouponsByExpediteur(this.currentUser.ID).subscribe((res)=>{
            if(res && res.result && res.result.datas){
                let datas = res.result.datas
                this.countCredit = datas.countCredit ? datas.countCredit : ''
                this.couponsTotal = datas.couponsTotal ? datas.couponsTotal : ''
                this.couponsUsed = datas.couponsUsed ? datas.couponsUsed : ''
                this.couponsInUse = datas.couponsInUse ? datas.couponsInUse : ''
                this.couponsUnused = datas.couponsUnused ? datas.couponsUnused : ''
            }
        })
    }
    searchCoupon(){
        if(this.subscribe && this.subscribe['getCoupon']){
            this.subscribe['getCoupon'].unsubscribe();
        }
        this.subscribe['getCoupon'] = this.customerService.getCouponsByExpediteur(this.currentUser.ID, this.filters).subscribe((res) => {
            if(res && res.result && res.result.coupons){
                this.coupons = res.result.coupons
            }
        })
    }
    generateVoucher(){
        if(this.subscribe && this.subscribe['generateCodeVoucher']){
            this.subscribe['generateCodeVoucher'].unsubscribe();
        }
        //Ouverture de la modale -> génération d'un code voucher
        this.subscribe['generateCodeVoucher'] = this.customerService.generateCodeVoucher().subscribe((res) => {
            if(res && res.result){
                const dialogRef = this.dialog.open(GenerateVoucher, {
                    width: '100%',
                    panelClass:'voucher-dialog',
                    data:{
                        voucher:res.result,
                        userId:this.currentUser.ID,
                        is_abonnement:this.currentUser.abonnement.active_subscription
                    },
                });

                //Si validation du voucher => rechargement du tableau
                dialogRef.afterClosed().subscribe(result => {
                    if(result.create){
                        this.searchCoupon()
                        this.searchDataCoupons()
                    }
                });
                
            }
        })
    }

    deleteCoupon(coupon){
        if(this.subscribe && this.subscribe['deleteCoupon']){
            this.subscribe['deleteCoupon'].unsubscribe();
        }
        this.subscribe['deleteCoupon'] = this.customerService.deleteCoupon(coupon.id).subscribe((res) => {
            if(res && res.result && res.result.success){
                this.searchCoupon()
                this.searchDataCoupons()
            }
        })
    }

    copyVoucher(coupon){

        if(coupon.voucher){
            let textToCopy = this.currentUser.firstname+' ['+this.currentUser.name+'] '+"a le plaisir de vous adresser un coupon afin de vous permettre de créer un dossier sur le site Rupture by Cobham pour effectuer un calcul liés à la paie et à la rupture du contrat de travail."
            + '\r\n' +
            " Le code du coupon est "+coupon.voucher
            + '\r\n' +
            " Merci de suivre cette démarche pour utiliser votre coupon :"
            + '\r\n' +
            "1) Connectez-vous au site web Rupture by Cobham : rupture.cobham-solutions.fr "
            + '\r\n' +
            "2) Créez un compte ou identifiez-vous"
            + '\r\n' +
            "3) Créez un dossier puis saisissez votre coupon à l'étape \"modalités de paiement\" "
            + '\r\n' +
            " Une question sur Cobham-Rupture ou besoin d'informations complémentaires ? "
            + '\r\n' +
            "N'hésitez pas à nous contacter par mail ou par téléphone, gratuitement au XX XX XX XX."
            + '\r\n' +
            "Notre service client est à votre disposition du lundi au vendredi de 9h à 17h."

            ctrlC(textToCopy).then((res)=>{
                this.textCopied = true
                this.voucherCopied = coupon.id
                setTimeout(()=>{
                    this.textCopied = false
                    this.voucherCopied = ''
                }, 3000)
            })

          
        }
    }

    sendVoucher(coupon){
        let linkSend = document.createElement("a")
        let href = "mailto:"
        if(coupon.destinataire)
            href+=coupon.destinataire
        href+="?subject=Rupture by Cobham - coupon offert&cc="
        href+=this.currentUser.email

        //TODO: Body du mail à modifier lorsque Bertrand aura les spec
        href+="&body="
        href+=this.currentUser.firstname+' ['+this.currentUser.name+'] '+"a le plaisir de vous adresser un coupon afin de vous permettre de créer un dossier sur le site Rupture by Cobham pour effectuer un calcul liés à la paie et à la rupture du contrat de travail."
        + '\r\n' +
        " Le code du coupon est "+coupon.voucher
        + '\r\n' +
        " Merci de suivre cette démarche pour utiliser votre coupon :"
        + '\r\n' +
        "1) Connectez-vous au site web Rupture by Cobham : rupture.cobham-solutions.fr "
        + '\r\n' +
        "2) Créez un compte ou identifiez-vous"
        + '\r\n' +
        "3) Créez un dossier puis saisissez votre coupon à l'étape \"modalités de paiement\" "
        + '\r\n' +
        " Une question sur Cobham-Rupture ou besoin d'informations complémentaires ? "
        + '\r\n' +
        "N'hésitez pas à nous contacter par mail ou par téléphone, gratuitement au XX XX XX XX."
        + '\r\n' +
        "Notre service client est à votre disposition du lundi au vendredi de 9h à 17h."

        linkSend.href = href
        document.body.appendChild(linkSend)
        linkSend.click()
        document.body.removeChild(linkSend)
    }
    ngOnDestroy(){
        for(let element in this.subscribe){
            this.subscribe[element].unsubscribe();
            this.subscribe[element] = null;
        }
      }
    
      
}
async function ctrlC(text)
{
    try {
        await navigator.clipboard.writeText(text)
    } catch (err) {
        let textArea = document.createElement('textarea')
        textArea.value = text
        document.body.appendChild(textArea)
        textArea.focus()
        textArea.select()
        
        document.execCommand('copy')
        textArea.remove()
    }
}